import React from "react";
import { Box, Typography } from "@mui/material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MetricCard from "./common/MetricCard";
import OfferCard from "./common/OfferCard";
import OfferRow from "./common/OfferRow";

export default function OffersOverviewPanel({ data }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {/* Row 1: Metrics */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
          gap: 2,
        }}
      >
        <MetricCard
          icon={<CardGiftcardIcon color="primary" />}
          label="Available Offers"
          value={data.availableOffers}
          valueColor="primary.main"
        />
        <MetricCard
          icon={<TrendingUpIcon sx={{ color: "success.main" }} />}
          label="Potential Value"
          value={`$${data.potentialValue.toLocaleString()}`}
          valueColor="success.main"
        />
        <MetricCard
          icon={<AccessTimeIcon sx={{ color: "warning.main" }} />}
          label="Expiring Soon"
          value={data.expiringSoon}
          valueColor="warning.main"
        />
      </Box>

      {/* Row 2: Personalized Recommendations */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Personalized Recommendations
        </Typography>
        {data.recommendations.map((offer, idx) => (
          <OfferCard key={idx} offer={offer} />
        ))}
      </Box>

      {/* Row 3+: Grouped Offers by Bank */}
      {data.groupedOffers.map((group, idx) => (
        <OfferRow key={idx} bankName={group.bank} offers={group.offers} />
      ))}
    </Box>
  );
}
